import { NycbsPharmaOrderModel } from "../../../data-model/nycbsPharmaOrder";
import { NycbsPharmaOrderKeys } from "../../../enums/nycbsPharmaOrder";
import { calculateAge } from "../../../utils/ageCalculator";
import { generateFullName } from "../../../utils/generateOrderDataForTable";
import { capitalizeString } from "../../../utils/stringModifications";
import { getPortalNameFromMetadata } from "../../cmmOrder/table/utils/getPortalNameFromMetadata";

interface PatientInfoBadgesProps {
  singleCmmOrderData: NycbsPharmaOrderModel | undefined;
}

const PatientInfoBadges = ({ singleCmmOrderData }: PatientInfoBadgesProps) => {
  return (
    <>
      <div className="insurance-details__body-patient-name rounded-[1.875rem] bg-primaryGray-16 px-4 text-small font-semibold leading-6 text-primaryGray-1">
        {capitalizeString(
          generateFullName(
            singleCmmOrderData?.[NycbsPharmaOrderKeys.PatientFirstName] || "",
            "",
            singleCmmOrderData?.[NycbsPharmaOrderKeys.PatientLastName] || "",
          ),
        )}
        &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
        {singleCmmOrderData?.[NycbsPharmaOrderKeys.PatientMrn] ?? ""}
        &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
        {singleCmmOrderData?.[NycbsPharmaOrderKeys.PatientDob] ?? ""}
        &nbsp;&nbsp;(
        {calculateAge(
          singleCmmOrderData?.[NycbsPharmaOrderKeys.PatientDob] ?? "",
        )}
        yrs) &nbsp;&nbsp;<span>&#8226;</span>&nbsp;&nbsp;
        {singleCmmOrderData?.[NycbsPharmaOrderKeys.DrugName]?.split(" ")[0] ??
          ""}
      </div>
      <div className="rounded-[1.875rem] bg-primaryGray-16 px-4 text-small font-semibold leading-6 text-primaryGray-1">
        {singleCmmOrderData?.type ?? ""}
      </div>
      <div className="rounded-[1.875rem] bg-primaryGray-16 px-4 text-small font-semibold leading-6 text-primaryGray-1">
        {getPortalNameFromMetadata(
          singleCmmOrderData?.[NycbsPharmaOrderKeys.Metadata],
        ) ?? ""}
      </div>
    </>
  );
};

export default PatientInfoBadges;
